export default "__VITE_ASSET__EDf1sqdB__"